import React from "react"
import { Box } from "@mui/material"
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutlineOutlined"
import WarningAmberIcon from "@mui/icons-material/Warning"
import { CAUTION, CAUTION_TINT, DANGER, DANGER_TINT } from "@/theme/tokens"
import { alpha } from "@mui/material/styles"

export const CHIP_SEVERITY = {
  error: {
    color: "#5f2120",
    bgcolor: DANGER_TINT,
    border: `1px solid ${alpha(DANGER, 0.2)}`,
    icon: DANGER,
  },
  warning: {
    color: "#663c00",
    bgcolor: CAUTION_TINT,
    border: `1px solid ${alpha(CAUTION, 0.2)}`,
    icon: CAUTION,
  },
  success: {
    color: "#1e4620",
    bgcolor: "rgba(237, 247, 237, 0.95)",
    border: "1px solid rgba(46, 125, 50, 0.20)",
    icon: "#2e7d32",
  },
}

const CHIP_BASE_SX = {
  display: "inline-flex",
  alignItems: "center",
  gap: 0.5,
  px: 1,
  py: 0.4,
  borderRadius: "11px",
  fontSize: "12px",
  fontWeight: 600,
}

export default function WarnChip({ severity, children, sx, onClick }) {
  const s = CHIP_SEVERITY[severity] ?? CHIP_SEVERITY.warning
  const Icon = severity === "success" ? CheckCircleOutlineIcon : WarningAmberIcon
  return (
    <Box
      onClick={onClick}
      sx={{ ...CHIP_BASE_SX, color: s.color, bgcolor: s.bgcolor, border: s.border, ...sx }}
    >
      <Icon sx={{ fontSize: 16, color: s.icon }} />
      {children}
    </Box>
  )
}
